'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-4">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-neutral-100">Something went wrong</h2>
      <p className="text-sm text-gray-600 dark:text-neutral-400">{error.message}</p>
      <button
        onClick={reset}
        className="rounded-md bg-brand-dark px-4 py-2 text-sm text-white hover:bg-neutral-800 dark:bg-neutral-200 dark:text-brand-dark dark:hover:bg-white"
      >
        Try again
      </button>
    </div>
  );
}
